import {Component, Input, Output, EventEmitter} from '@angular/core';

@Component({
    selector: 'app-view-farm-user',
    templateUrl: './view-farm-user.component.html',
    styleUrls: ['./view-farm-user.component.scss']
})
export class ViewFarmUserComponent {
    @Input() userDetails: any = null;
    @Output() closeDialog = new EventEmitter<void>();

    isLoading: boolean = false;

    onClose(): void {
        this.closeDialog.emit();
    }
}
